
import { Component, ElementRef, Input, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { escapeHtml, escapeRegExp } from 'src/app/common/_helpers/html-sanitizer.util';
import { trigger, transition, style, animate, query, group, animateChild } from '@angular/animations';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { COMMON_CONSTANTS } from 'src/app/common/constants/common-constants';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatbotService } from 'src/app/common/services/chatbot.service';
import { MsalService } from '@azure/msal-angular';
import { protectedResources } from 'src/app/auth.config';
import { v4 as uuidv4 } from 'uuid';

interface Client {
  ClientName: string;
  showStudies: boolean;
  UniqueStudies: string[];
}
interface Snapshot {
  type: string;
  name: string;
  section: string;
  subSection: string;
}

@Component({
  selector: 'app-module-tile-landing',
  templateUrl: './module-tile-landing.component.html',
  styleUrls: ['./module-tile-landing.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    /* Simpler state-based animation to avoid overlapping text during page changes */
    trigger('tabSlide', [
      transition(':increment', [
        style({ transform: 'translateX(26px)', opacity: 0 }),
        animate('130ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':decrement', [
        style({ transform: 'translateX(-26px)', opacity: 0 }),
        animate('130ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ])
    ])
  ]
})

export class ModuleTileLandingComponent implements OnDestroy {

  private resizeHandler = () => this.updateVisibleCount();

  // Used for template to control arrow visibility
  get totalSnapshots(): number {
    return this.filteredStudyNamesArray?.length || 0;
  }

  CrossTabName: string = COMMON_CONSTANTS.CrossTabModuleName;
  SnapShotName: string = COMMON_CONSTANTS.SnapShotModuleName;
  BrandAnalysisName: string = COMMON_CONSTANTS.BrandAnalysisModuleName;
  ReportGeneratorName: string = COMMON_CONSTANTS.ReportGeneratorModuleName;
  ArkName: string = COMMON_CONSTANTS.ARKName;
  MidYearReportName: string = COMMON_CONSTANTS.MidYearReportName;

  studydropdown: boolean = false;
  Acrossdropdowncheck: boolean = false;
  isSnapshot: boolean = false;
  enableExplore: boolean = false;
  enableConfig: boolean = false;
  isCustomSnapshotWidgetLibrary: boolean = true;
  studyname: any = "study Name";
  Acrossname: any = "compare Across";
  filteredData: any[] = [];
  popUpData: any;
  AcrossDropdown: any;
  studyNamesCount: any = 0;
  studyNamesArray: any;
  filteredStudyNamesArray: any;
  searchStudyText: string = '';
  snapshotselected: any = "";
  sectionSelected: any = "";
  subsectinselected: any = "";
  exploreBtn: string = "Explore";
  IsBrandAnalysis: boolean = false;
  snapshotType: any = [];

  @Input() moduleName: string = '';
  @Input() studyNames: any;
  @Input() studyName: any = '';
  @Input() ClientName: any;
  @Input() isSuperAdmin: any;
  @Input() configData: any;

  @ViewChild('searchInput') searchInput!: ElementRef;

  private subscriptions: Subscription = new Subscription();

  constructor(private router: Router, private sanitizer: DomSanitizer,
    private _loaderService: LoaderService, private _configService: SnapshotService,
    public SharedPopupService: SharedPopupService, private _configCustomService: CustomsnapshotService,
    private chatbotService: ChatbotService, private msalService: MsalService) { }

  ngOnInit() {
    this.studyNamesArray = this.studyNames ?? [];
    this.filteredStudyNamesArray = this.studyNamesArray;
    this.studyNamesCount = this.studyNamesArray.length;

    if (this.moduleName == this.SnapShotName) {
      this.studyname = "Snapshot Name";
      this.getPopUpeData();
      this.toggleStudies(this.ClientName);
      this.isSnapshot = true;
      this.studyNamesArray.sort((a: string, b: string) =>
        a.trim().toLowerCase().localeCompare(b.trim().toLowerCase())
      );
      if(!this.isSuperAdmin){
        this._loaderService.showLoader();
        this._configService
          .getAllSnapshotData(this.ClientName)
          .subscribe(
                (snapshots:any) => {
              if (snapshots) {
                let snapshotsRecord = JSON.parse(snapshots.Data);
                    if(snapshotsRecord.length > 0){
                  // this.studyNames = snapshotsRecord
                  //   .filter((record: any) =>
                  //     record.snapshotType_details.some(
                  //       (detail: any) => detail.entry_point.length > 0
                  //     )
                  //   )
                  //   .map((record: any) => record.snapshot_name);

                  //   this.studyNames = snapshotsRecord
                  //   .filter((record: any) =>
                  //     record.snapshotType_details?.some(
                  //       (detail: any) => detail.entry_point?.length > 0
                  //     )
                  //   )
                  //   .map((record: any) => record.snapshot_name);

                  // if (this.studyNames.length > 0) {
                  //   this.studyNamesArray = this.studyNames;

                  //   this.studyNamesArray.sort((a: string, b: string) =>
                  //     a.trim().toLowerCase().localeCompare(b.trim().toLowerCase())
                  //   );
                  //   this.studyNamesCount = this.studyNames.length;
                  //   this.filteredStudyNamesArray = this.studyNamesArray;
                  //   this.studyNameclick(this.filteredStudyNamesArray[0])
                  // } else {
                  //   this.isCustomSnapshotWidgetLibrary = false;
                  // }



                  this.studyNamesArray = this.studyNames;

                  this.studyNamesArray.sort((a: string, b: string) =>
                    a.trim().toLowerCase().localeCompare(b.trim().toLowerCase())
                  );
                  this.studyNamesCount = this.studyNames.length;
                  this.filteredStudyNamesArray = this.studyNamesArray;
                  this.studyNameclick(this.filteredStudyNamesArray[0])




                  }else{
                  this.isCustomSnapshotWidgetLibrary = false;
                }
              }
              this._loaderService.hideLoader();
            },
            (err) => {
              console.error("Error fetching all snapshots:", err);
              this._loaderService.hideLoader();
            }
          );
      }else {
        this.filteredStudyNamesArray = this.studyNamesArray;
        this.studyNameclick(this.filteredStudyNamesArray[0])
      }
    }
    else {
      this.isSnapshot = false;
      this.exploreBtn = this.isSuperAdmin ? this.exploreBtn : this.exploreBtn;
      this.studyname = this.studyName;
      if (!this.isSuperAdmin) {
        this.navigateToModule();
      }
    }
    this.updateVisibleCount();
    window.addEventListener('resize', this.resizeHandler);
  }
  isOpen = false;
  searchText = '';
  snapshots: Snapshot[] = [];

  toggleSearch() {
    this.isOpen = !this.isOpen;
      this.searchText ='';
    if (this.isOpen) {
      setTimeout(() => this.searchInput.nativeElement.focus(), 0);
    }
  }

  get filteredSnapshots(): Snapshot[] {
    return this.snapshots.filter(s =>
      s.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
      s.section.toLowerCase().includes(this.searchText.toLowerCase()) ||
      s.subSection.toLowerCase().includes(this.searchText.toLowerCase()) ||
      s.type.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  highlightText(text: string): SafeHtml {
    if (!this.searchText) return text;
      text =  this._configService.capitalizeWords(text);
    const search = escapeRegExp(this.searchText.trim());
    const regex = new RegExp(`(${search})`, 'gi');
    const result = escapeHtml(text).replace(regex, `<mark>$1</mark>`);

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  combineHighlight(section: string, subSection: string): SafeHtml {
    const combined = `${section} - ${subSection}`;
    return this.highlightText(combined);
  }


  selectSnapshot(snapshot: any) {
    this.searchText = snapshot.name;
    this.isOpen = false;
    this.studyNameclick(snapshot.name);
    this.AcrossNameclick(snapshot.type,snapshot.section,snapshot.subSection);
  }

  activeIndex: number = 0;
  setActiveTab(index: number) {
    this.activeIndex = index;
  }

  getPopUpeData(): void {
    this.SharedPopupService.setPopUpTabData$.subscribe((data) => {
      if (data != null && data.data.length > 0) {
        this.popUpData = data.data;
        this.filteredData = data.data;
        this._configService.SnapshotList = data.data;
      }
    });
  }

  openstudyDropdown() {
    this.Acrossdropdowncheck = false;
    this.studydropdown = !this.studydropdown;
  }

  studyNameclick(name: any, index: number = 0) {

    this.activeIndex = this.pageIndex * this.visibleCount + index;

    this.studyname = name;
    if (!this.isSnapshot) {
      this.enableExplore = true;
    }

    this.enableConfig = true;
    this.Acrossname = "compare Across";
    this.studydropdown = false;
    this.AcrossDropdown = [];
    if (this.isSnapshot)
      this.bindingAcrossDropdown();
  }

  AcrossNameclick(snapshot_name: any, sectionname: any, subsection: any) {
    this.snapshotselected = snapshot_name;
    this.sectionSelected = sectionname;
    this.subsectinselected = subsection;
    this._configService.snapshotSelectedName = this.snapshotselected;
    this._configService.selectedSection = this.sectionSelected;
    this._configService.selectedSubSection = this.subsectinselected;
    this.Acrossdropdowncheck = false;
    if (subsection == '')
      this.Acrossname = snapshot_name.toUpperCase() + ' : ' + sectionname;
    else
      this.Acrossname = snapshot_name.toUpperCase() + ' : ' + sectionname + ' : ' + subsection;

    this.enableConfig = true;
    this.enableExplore = true;

    this.navigateToModule();
  }

  configuration() {
    if (this.isSnapshot) {
      if (this.studyname == 'Snapshot Name') {
        let data: { client_name: string; study: string; configdata: any } = {
          client_name: this.ClientName,
          study: "",
          configdata: this.filteredData,
        };
        this.router.navigateByUrl('Snapshot/configuaration', { state: data });
      }
      else {
        let data: { client_name: string; study: string; configdata: any; snapshotselected: string, sectionselected: any; subsectionselected: any } = {
          client_name: this.ClientName,
          study: this.studyName,
          configdata: this.filteredData,
          snapshotselected: this.studyname,
          sectionselected: this._configService.selectedSection,
          subsectionselected: this._configService.selectedSubSection
        };
        this.router.navigateByUrl('Snapshot/configuaration', { state: data });
      }
    } else {

      let data: { client_name: string; study: string } = {
        client_name: this.ClientName,
        study: this.studyName,
      };
      this.router.navigateByUrl('configuration', { state: data });
    }
  }


  toggleStudies(clickedClient: any): void {
    this.popUpData?.forEach((client: Client) => {
      if (client.ClientName !== clickedClient) {
        client.showStudies = false;
      }
      else {
        client.showStudies = true;
      }
    });
  }
  // bindingAcrossDropdown() {
  //   this._loaderService.showLoader();
  //   if (this.studyname != "study Name" && this.ClientName != '') {
  //     let snapshotData = {
  //       ClientName: this.ClientName,
  //       SnapshotName: this.studyname
  //     }
  //     this._configService
  //         .getClientStudyData({
  //           client_code: this.ClientName,
  //           snapshot_name: this.studyname,
  //         })
  //         .subscribe({
  //           next: (response) => {
  //             const data = JSON.parse(response.body?.Data ?? '{}');

  //             if (data?.snapshotType_details) {
  //               this.snapshotType = data.snapshotType_details;
  //             }
  //             if(data?.saveselection){
  //               this._configService.globalDefaultSelectionFlag = data.saveselection.find(
  //                 (item: { key: string; value: boolean }) => item.key === "Global Default Selection"
  //               )?.value ?? false;
  //             }
  //             this._configCustomService.getCustomSnapshotWidgetLibrary(snapshotData).subscribe((r: any) => {
  //               let data = r?.Data
  //               if(data) {
  //                 this.isCustomSnapshotWidgetLibrary = true;
  //                 let configuredSnapshotTypes = JSON.parse(data);
  //                 const snapshotTypeSet = new Set(
  //                   this.snapshotType.map((item: { snapshot_type: string }) => item.snapshot_type)
  //                 );

  //                 configuredSnapshotTypes.snapshotType = configuredSnapshotTypes.snapshotType.filter(
  //                   (item: { snapshotType_name: string }) =>
  //                     snapshotTypeSet.has(item.snapshotType_name)
  //                 );

  //                 const sortOrder = ['Single Brand', 'Multiple Brands', 'Multiple Markets'];
  //                 configuredSnapshotTypes.snapshotType.sort((a: any, b: any) => {
  //                   return sortOrder.indexOf(a.snapshotType_name) - sortOrder.indexOf(b.snapshotType_name);
  //                 });

  //                 this.AcrossDropdown = configuredSnapshotTypes?.snapshotType;
  //                 this._configService.AcrossDropdown = this.AcrossDropdown;
  //                 localStorage.setItem("AcrossDropdown", JSON.stringify(this.AcrossDropdown));

  //                 if (this.AcrossDropdown?.length) {
  //                   this.snapshots = [];
  //                   for (const dropdown of this.AcrossDropdown) {
  //                     for (const section of dropdown.section || []) {
  //                       const subsections = section.subsection || [];

  //                       if (subsections.length === 0 || subsections[0]?.subsection_name === 'NA') {
  //                         this.snapshots.push({
  //                           name: this._configService.capitalizeWords(this.studyname),
  //                           type: this._configService.capitalizeWords(dropdown.snapshotType_name),
  //                           section: this._configService.capitalizeWords(section.section_name),
  //                           subSection:"",
  //                         });
  //                       } else {
  //                         for (const subsection of subsections) {
  //                           this.snapshots.push({
  //                             name: this._configService.capitalizeWords(this.studyname),
  //                             type: this._configService.capitalizeWords(dropdown.snapshotType_name),
  //                             section: this._configService.capitalizeWords(section.section_name),
  //                             subSection: this._configService.capitalizeWords(subsection.subsection_name)
  //                           });
  //                         }
  //                       }
  //                     }
  //                   }
  //                 }
  //               } else{
  //                  this.isCustomSnapshotWidgetLibrary = false;
  //               }
  //               this._loaderService.hideLoader();
  //             },
  //               (error) => {
  //                 console.error('Error:', error);
  //                 this._loaderService.hideLoader();
  //               }
  //             );
  //           },
  //           error: (err) => {
  //             console.error('Error fetching client study data:', err);
  //             this._loaderService.hideLoader();
  //           }
  //         });
  //   }
  // }

  bindingAcrossDropdown() {
    this._loaderService.showLoader();
    if (this.studyname != "study Name" && this.ClientName != '' && this.studyname != "") {
      const snapshotData = {
        ClientName: this.ClientName,
        SnapshotName: this.studyname
      };
      const cached = this._configService.getSnapshotByName(this.studyname,this.ClientName);
      if (cached) {
        this.processSnapshotData(cached, snapshotData);
        this._loaderService.hideLoader();
      } else {
        this._configService
          .getAllSnapshotData(this.ClientName)
          .subscribe({
            next: (snapshots) => {
              const snapshot = this._configService.getSnapshotByName(this.studyname,this.ClientName);                  
              if (snapshot) {
                this.processSnapshotData(snapshot, snapshotData);
              } else {
                console.warn("Snapshot not found:", this.studyname);
                this.isCustomSnapshotWidgetLibrary = false;
              }
              this._loaderService.hideLoader();
            },
            error: (err) => {
              console.error("Error fetching all snapshots:", err);
              this._loaderService.hideLoader();
            }
          });
      }
    }
    else{
      this._loaderService.hideLoader();
    }
  }
  processSnapshotData(data: any, snapshotData: any) {
    if (data?.snapshotType_details) {
      this.snapshotType = data.snapshotType_details;
    }
    if (data?.saveselection) {
      this._configService.globalDefaultSelectionFlag = data.saveselection.find(
        (item: { key: string; value: boolean }) => item.key === "Global Default Selection"
      )?.value ?? false;
    }

    this._configService.isCustomBaseSelected = data.isCustomBaseSelected;

    const customSnapshotWidgetLibrary = this._configCustomService.getCustomSnapshotWidgetLibraryByName(this.studyname, this.ClientName);
    if(customSnapshotWidgetLibrary){
      if(this.snapshots && this.snapshots.length == 0 && this._configCustomService.allCustomSnapshotWidgetLibrary.length > 0){
        this.snapshots = this.buildSearchSnapshots(this._configCustomService.allCustomSnapshotWidgetLibrary);
        this.isCustomSnapshotWidgetLibrary = true;
      }
      this.handleLibraryData(customSnapshotWidgetLibrary)
    } else {
      this._configCustomService.getAllCustomSnapshotWidgetLibrary(this.ClientName, this.filteredStudyNamesArray)
        .subscribe({
          next: (snapshots:any) => {
            if(!snapshots.Data) {
              this.isCustomSnapshotWidgetLibrary = false;
            }
            if(this.isCustomSnapshotWidgetLibrary) {
              const snapshotWidgetLibraryRecord = JSON.parse(snapshots.Data);
              this.snapshots = this.buildSearchSnapshots(snapshotWidgetLibraryRecord);
              const customSnapshotWidgetLibrary = this._configCustomService.getCustomSnapshotWidgetLibraryByName(this.studyname, this.ClientName);
              if (customSnapshotWidgetLibrary) {
                this.handleLibraryData(customSnapshotWidgetLibrary);
              } else {
                console.warn("Library not found:", this.studyname);
                this.isCustomSnapshotWidgetLibrary = false;
              }
            }
            this._loaderService.hideLoader();
          },
          error: (err) => {
            console.error("Error fetching all Library:", err);
            this._loaderService.hideLoader();
          }
        });
    }
  }


  buildSearchSnapshots(snapshotWidgetLibraryRecord: any[]): any[] {
    const snapshots: any[] = [];

    for (const item of snapshotWidgetLibraryRecord || []) {
      if (!item?.snapshotType?.length) continue;

      for (const dropdown of item.snapshotType) {
        for (const section of dropdown.section || []) {
          const subsections = section.subsection || [];

          if (subsections.length === 0 || subsections[0]?.subsection_name === 'NA') {
            snapshots.push({
              name: item.snapshot_name,
              type: dropdown.snapshotType_name,
              section: section.section_name,
              subSection: "",
            });
          } else {
            for (const subsection of subsections) {
              snapshots.push({
                name: item.snapshot_name,
                type: dropdown.snapshotType_name,
                section: section.section_name,
                subSection: subsection.subsection_name,
              });
            }
          }
        }
      }
    }

    return snapshots;
  }


  handleLibraryData(libData: any) {
    this.isCustomSnapshotWidgetLibrary = true;
    let configuredSnapshotTypes = libData;
    const snapshotTypeSet = new Set(
      this.snapshotType.map((item: { snapshot_type: string }) => item.snapshot_type)
    );

    configuredSnapshotTypes.snapshotType =
      configuredSnapshotTypes.snapshotType.filter(
        (item: { snapshotType_name: string }) => snapshotTypeSet.has(item.snapshotType_name)
      );

    const sortOrder = ['Single Brand', 'Multiple Brands', 'Multiple Markets','Audience Snapshot'];
    configuredSnapshotTypes.snapshotType.sort((a: any, b: any) => {
      return sortOrder.indexOf(a.snapshotType_name) - sortOrder.indexOf(b.snapshotType_name);
    });

    this.AcrossDropdown = configuredSnapshotTypes?.snapshotType;
    if (this.AcrossDropdown?.length === 1 && !this.isSuperAdmin) {
      const type = this.AcrossDropdown[0];
      const sections = type.section || [];
      if (sections.length === 1) {
        const section = sections[0];
        const subsections = section.subsection || [];
        if (subsections.length <= 1) {
          const subsectionName = subsections[0]?.subsection_name === 'NA' ? '' : subsections[0]?.subsection_name || '';
          // SET VALUES
          this._configService.snapshotSelectedName = type.snapshotType_name;
          this._configService.selectedSection = section.section_name;
          this._configService.selectedSubSection = subsectionName;
          this.navigateToSnapshot();
          return; 
        }
      }
    }

    this._configService.AcrossDropdown = this.AcrossDropdown;
    sessionStorage.setItem("AcrossDropdown", JSON.stringify(this.AcrossDropdown));
  }

  navigateToModule() {
    const finalStudyList = this.studyNamesArray ?? this.studyNames ?? [];
    let data: { client_code: string; study: string; studyList: any } = {
      client_code: this.ClientName,
      study: this.studyName,
      studyList: finalStudyList
    };
    switch (this.moduleName) {
      case this.SnapShotName:
        this.navigateToSnapshot();
        break;
      case this.CrossTabName:
        this.router.navigateByUrl('Crosstab', { state: data });
        break;
      case this.BrandAnalysisName:
        this.router.navigateByUrl('BrandAnalysis', { state: data });
        break;
      case this.ReportGeneratorName:
        this.router.navigateByUrl('US-Brand-Perception-Report', { state: data });
        break;
      case this.MidYearReportName:
        this.router.navigateByUrl('Mid-Year-Report', { state: data });
        break;
      case this.ArkName:
        this.navigateToArkWithAccessCheck(data);
        break;
    }
  }

  navigateToSnapshot() {
  const cached = this._configService.getSnapshotByName(this.studyname,this.ClientName);
    if (cached) {
      this.handleNavigateSnapshot(cached);
    } else {
      this.subscriptions.add(
        this._configService.getClientStudyData({
          client_code: this.ClientName,
          snapshot_name: this.studyname,
        })
          .subscribe((b) => {
            const parsed = JSON.parse(b.body.Data);
            if (parsed) {
              this.handleNavigateSnapshot(parsed);
            } else {
              this.router.navigateByUrl('landing');
            }
          })
      );
    }
  }


  navigateToArkWithAccessCheck(data: any) {
    let account = this.msalService.instance.getActiveAccount();
    if (!account) {
      const accounts = this.msalService.instance.getAllAccounts();
      if (accounts && accounts.length > 0) {
        account = accounts[0];
        this.msalService.instance.setActiveAccount(account);
      }
    }

    if (account) {
      this._loaderService.hideLoader();
      data['fromLandingPage'] = true;
      this.router.navigateByUrl('chatbotexpand', { state: data });
    } else {
      this._loaderService.hideLoader();
      data['fromLandingPage'] = true;
      this.router.navigateByUrl('chatbotexpand', { state: data });
    }
  }

  handleNavigateSnapshot(snapshot: any) {
    const mainStudy = snapshot.study_list[0].study_name;
    const data = {
      client_code: this.ClientName,
      study: this.studyname,
      main_study: mainStudy,
      snapList: this._configService.SnapshotList?.filter((a: any) => a.ClientName === this.ClientName),
      snapshotselected: this._configService.snapshotSelectedName,
      sectionselected: this._configService.selectedSection,
      subsectionselected: this._configService.selectedSubSection,
    };

    localStorage.setItem("snapshotselected_landing", this._configService.snapshotSelectedName);
    localStorage.setItem("sectionselected_landing", this._configService.selectedSection);
    localStorage.setItem("subsectionselected_landing", this._configService.selectedSubSection);

    // Navigate based on product
    const route = snapshot.product === "Standard"
      ? 'Snapshot/snapshot-output'
      : 'Snapshot/custom-snapshot-output';

    this.router.navigateByUrl(route, { state: data });
  }


  pageIndex = 0;          // which "page" of tabs we’re on
  // visibleCount =  4;
  // visibleCount = window.innerWidth > 1600 ? 5 : 4;
  visibleCount = 4;



  updateVisibleCount() {
    // this.visibleCount = window.innerWidth > 1600 ? 4 : 4;
    this.visibleCount = 4;
  }

  get visibleTabs() {
    const start = this.pageIndex * this.visibleCount;
    return this.filteredStudyNamesArray.slice(start, start + this.visibleCount);
  }

  selectTab(index: number) {
    this.activeIndex = index;
  }

  showPrev() {
    if (this.pageIndex > 0) {
      this.pageIndex--;
    }
  }

  showNext() {
    if ((this.pageIndex + 1) * this.visibleCount < this.filteredStudyNamesArray.length) {
      this.pageIndex++;
    }
  }

  get canShowPrev() {
    return this.pageIndex > 0;
  }

  get canShowNext() {
    return (this.pageIndex + 1) * this.visibleCount < this.filteredStudyNamesArray.length;
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    this.subscriptions.unsubscribe();
  }
}
